<template>
  <div id="overlay-search" v-show="showContent" v-on:click.self="closeModal">
    <div id="content-search" class="action-close">
      <div id="search-tab">
        <ul class="search-category">
          <li v-on:click="change('item')" v-bind:class="{'active': isActive === 'item'}">報酬</li>
        </ul>
        <hr class="main-border">
        <div class="search-contents">
          <div v-if="isActive === 'item'">
            <div class="search-item" v-for="(category, key) in itemCategory" :key="key">
              <div v-if="category.item_type==='1'">
                <div v-for="(weapon_types, key) in category.weapon_category" :key="key">
                  {{weapon_types.weapon_category}}
                  <hr class="sub-border">
                  <div class="search-item-list" v-for="(searchItem, key) in getSearchItemList()" :key="key">
                    <div class="item-label" v-if="category.item_type===searchItem.item_type && weapon_types.weapon_type===searchItem.weapon_type">
                      <input type="checkbox" v-bind:id=searchItem.item_id v-bind:value=searchItem.item_id v-model="checkedValues">
                      <label v-bind:for=searchItem.item_id>{{searchItem.item_name}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                {{category.category_name}}
                <hr class="sub-border">
                <div class="search-item-list" v-for="(searchItem, key) in getSearchItemList()" :key="key">
                  <div class="item-label" v-if="category.item_type===searchItem.item_type">
                    <input type="checkbox" v-bind:id=searchItem.item_id v-bind:value=searchItem.item_id v-model="checkedValues">
                    <label v-if="searchItem.item_type==='3'" v-bind:for=searchItem.item_id>艦娘『{{searchItem.item_name}}』</label>
                    <label v-else-if="searchItem.item_type==='4'" v-bind:for=searchItem.item_id>家具『{{searchItem.item_name}}』</label>
                    <label v-else-if="searchItem.item_type==='5'" v-bind:for=searchItem.item_id>『{{searchItem.item_name}}』の開放</label>
                    <label v-else v-bind:for=searchItem.item_id>{{searchItem.item_name}}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="main-border">
      </div>
      <div id="buttons">
        <div id="clear-button" @click="clearCheck()">クリア</div>
        <div id="search-button" @click="searchQuest()">検索</div>
      </div>
      <div>
        <button class="btn" v-on:click="closeModal">×</button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  props: ['showContent', 'quest'],
  data () {
    return {
      isActive: 'item',
      checkedValues: [],
      tempCheckedValues: [],
      itemCategory: [
        {
          'category_name': '装備',
          'item_type': '1',
          'weapon_category': [
            {'weapon_category': '小口径主砲', 'weapon_type': '010000'},
            {'weapon_category': '中口径主砲', 'weapon_type': '020000'},
            {'weapon_category': '大口径主砲', 'weapon_type': '030000'},
            {'weapon_category': '副砲', 'weapon_type': '040000'},
            {'weapon_category': '魚雷', 'weapon_type': '050000'},
            {'weapon_category': '輸送・上陸用舟艇', 'weapon_type': '060000'},
            {'weapon_category': '艦上戦闘機', 'weapon_type': '070000'},
            {'weapon_category': '艦上爆撃機', 'weapon_type': '080000'},
            {'weapon_category': '艦上攻撃機', 'weapon_type': '090000'},
            {'weapon_category': '艦上偵察機', 'weapon_type': '100000'},
            {'weapon_category': '水上戦闘機', 'weapon_type': '110000'},
            {'weapon_category': '水上爆撃機', 'weapon_type': '120000'},
            {'weapon_category': '水上偵察機', 'weapon_type': '130000'},
            {'weapon_category': '対潜哨戒機', 'weapon_type': '140000'},
            {'weapon_category': '電探', 'weapon_type': '150000'},
            {'weapon_category': '機関', 'weapon_type': '160000'},
            {'weapon_category': '強化弾', 'weapon_type': '170000'},
            {'weapon_category': '対空機銃', 'weapon_type': '180000'},
            {'weapon_category': '高射装置', 'weapon_type': '190000'},
            {'weapon_category': '爆雷・爆雷投射機', 'weapon_type': '200000'},
            {'weapon_category': 'ソナー', 'weapon_type': '210000'},
            {'weapon_category': '増設バルジ', 'weapon_type': '220000'},
            {'weapon_category': '陸上攻撃機', 'weapon_type': '230000'},
            {'weapon_category': '局地戦闘機', 'weapon_type': '260000'},
            {'weapon_category': '陸上戦闘機', 'weapon_type': '270000'},
            {'weapon_category': 'その他', 'weapon_type': '280000'}
          ]
        },
        {
          'category_name': 'アイテム',
          'item_type': '2',
          'weapon_category': []
        },
        {
          'category_name': '艦娘',
          'item_type': '3',
          'weapon_category': []
        },
        {
          'category_name': '家具',
          'item_type': '4',
          'weapon_category': []
        },
        {
          'category_name': 'システム',
          'item_type': '5',
          'weapon_category': []
        }
      ]
    }
  },
  methods: {
    closeModal: function () {
      // 検索モーダルのクローズ時には検索条件を元に戻す
      this.checkedValues = this.tempCheckedValues
      this.$emit('close')
    },
    change: function (num) {
      // 検索タブの変動チェック用
      this.isActive = num
    },
    clearCheck: function () {
      // 検索条件をクリアする
      this.checkedValues = []
    },
    searchQuest: function () {
      // 現在の検索条件をローカルストレージに保存
      localStorage.setItem('searchItem', JSON.stringify(this.checkedValues))
      // 検索条件を一時保存する
      this.tempCheckedValues = this.checkedValues
      // 検索実行
      this.fetchQuests()
      this.$emit('close')
    },
    protSearchItems: function () {
      // ページ生成時にローカルストレージから検索条件を復旧する
      var searchItems
      // nullチェック
      if (JSON.parse(localStorage.getItem('searchItem')) === null) {
        searchItems = []
      } else {
        searchItems = JSON.parse(localStorage.getItem('searchItem'))
      }
      // チェックした検索条件を復旧
      this.checkedValues = searchItems
      // 合わせて一時保存領域にも設定する
      this.tempCheckedValues = searchItems
    },
    ...mapActions(['fetchQuests']),
    ...mapGetters(['getSearchItemList'])
  },
  mounted () {
    this.protSearchItems()
  }
}
</script>

<style scoped>
ul {
  list-style-type: none;
}
#overlay-search{
  /* 要素を重ねた時の順番 */
  z-index:1;
  /* 画面全体を覆う設定 */
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.6);
  /* 画面の中央に要素を表示させる設定 */
  display: flex;
  align-items: center;
  justify-content: center;
}
#content-search{
  z-index:2;
  background-color:#F4EAE0;
  width: 99%;
  height: 680px;
  border: 2px solid;
  border-image: linear-gradient(to top, #877325, #C0B578);
  border-image-slice:1;
}
.btn {
  color: #FFFFFF;
  font-size: 20pt;
  background-color: #393836;
  padding: .3em .5em;
  text-align: center;
  cursor: pointer;
}
.btn:hover {
  cursor: pointer;
}
/* close button */
.action-close {
  position: relative;
  margin-top: 2em;
}
.action-close .btn {
  position: absolute;
  right: 0;
  top: -1em;
}
/* タブ用のstyle */
.search-category {
  overflow: hidden;
}
.search-category li {
  float: left;
  padding: 10px 20px;
  border: 1px solid #CCCCCC;
  cursor: pointer;
  transition: .3s;
}
.search-category li:not(:first-child) {
  border-left: none;
}
.search-category li.active {
  background-color: #5BB0BE;
  border-color: #000000;
  color: #FFFFFF;
  cursor: pointer;
}
.search-contents {
  overflow-y: scroll;
  margin-top: -1px;
  width: 900px;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
  height: 520px;
}
.search-item-list {
  margin: 10px;
}
hr.main-border {
  width: 100%;
}
.item-label {
  width: 50%;
  /* word-break: break-all; */
}
label, input[type='checkbox'] {
  cursor: pointer;
}
#buttons {
  display: flex;
}
#clear-button {
  width: 100px;
  margin-top: 5px;
  margin-left: 60px;
  margin-right: auto;
  border: solid;
  border-width: 1px;
  border-color: #AAAAAA;
  background-color: #DDDDDD;
  padding: 5px;
}
#clear-button:hover {
  cursor: pointer;
}
#search-button {
  width: 100px;
  margin-top: 5px;
  margin-right: 60px;
  border: solid;
  border-width: 1px;
  border-color: #000000;
  background-color: #5BB0BE;
  padding: 5px;
  color: #FFFFFF;
}
#search-button:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchModalSm.vue